import { PageHeader } from "@ant-design/pro-components";
import { List } from "antd";
import { observer } from 'mobx-react';
import React, { useEffect } from "react";
import { useStore } from "../../stores/root-store";
import '../common/page-header.css';
import TicketItem from "../ticket/ticket-item";
import Subjects from "../../models/subjects";
import Pagination from "../../models/pagination";

const TicketList: React.FC<{subject: Subjects}> = ({subject}) => {

    const { subjectStores, authStore } = useStore();
    const ticketList = subjectStores[subject].ticketList;

    useEffect(() => {
        if (authStore.isAuthenticated) {
            ticketList.loadStudentList();
            ticketList.loadList(1);
        }
    }, [ticketList, authStore.isAuthenticated]
    );

    return (
        <div className="content">
            <PageHeader title="Список созданных вариантов" className="site-page-header" />
            <List
                itemLayout="vertical"
                dataSource={ticketList.data}
                pagination={{
                    onChange: (page) => {
                        ticketList.loadList(page);
                    },
                    pageSize: Pagination.PAGE_SIZE,
                    current: ticketList.currentPage,
                    total: ticketList.totalCount
                }}
                renderItem={(item, indx) => (
                    <TicketItem {...{ ticket: item, indx: ticketList.getItemIndex(indx), students: ticketList.studentList, subject: subject }} />
                )}
            ></List>
        </div>
    );
};


export default observer(TicketList);